'use strict';
angular.module('upAttributes').service('ActivityTypeAttributes', [
	'FilterType',
	'DisplayType',
	function (FilterType, DisplayType) {
		return function () {
			var attributes = {
				id: {
					title: 'default.id',
					field: 'id',
					type: FilterType.Number,
					displayType: DisplayType.String,
					groupable: false,
					sortable: false,
					selectableColumn: false,
					filterable: false
				},
				name: {
					title: 'default.name',
					field: 'name',
					type: FilterType.String,
					groupable: false,
					sortable: false,
					selectableColumn: false,
					filterable: false
				},
				isFirstAppointment: {
					title: 'default.firstAppointment',
					field: 'isFirstAppointment',
					type: FilterType.Boolean
				}
			};

			return {
				getAll: function () {
					return attributes;
				}
			};
		};
	}
]);
